// Supervisão do Comercial (#6521, 29/10/2026).
//
// O Hunter (ainda vai ser contratado) ajuda a supervisionar a Júlia, a Thayla e quem
// mais entrar como Closer ou BDR. Como ainda não se sabe se haverá mais de um Hunter,
// nem se só o primeiro vai supervisionar, a supervisão é uma PERMISSÃO dada por pessoa
// (Config › Usuários › Permissões Especiais), e não uma regra presa à função.
//
// Combinado com o Felipe: quem supervisiona vê no CRM e no Analytics as negociações das
// Closers e BDRs, vê o SLA delas e transfere negociação entre elas. Aprovar desconto e
// mexer em escala continuam com a gerente.
//
// Isto aqui decide o que a tela mostra. A leitura do SLA da equipe depende também da
// RLS de negociacao_atribuicoes (fn_supervisiona_comercial, migration 20261029170000).
import { FUNCOES_COM_RODIZIO, funcaoComercial } from './departamentos.ts';

export const SUPERVISIONAR_COMERCIAL_PERMISSION = 'Supervisionar o Comercial';

interface PerfilSupervisao {
  id?: string | null;
  role?: string | null;
  status?: string | null;
  permissions?: string[] | null;
  funcao_comercial?: string | null;
}

const ativo = (p: PerfilSupervisao): boolean => (p.status ?? 'active') === 'active';

/** Tem a permissão de supervisionar o Comercial (e está ativo)? */
export const supervisionaComercial = (p: PerfilSupervisao | null | undefined): boolean =>
  !!p && ativo(p) && Array.isArray(p.permissions) && p.permissions.includes(SUPERVISIONAR_COMERCIAL_PERMISSION);

/** Faz parte da equipe que a supervisão acompanha: Closers e BDRs ativos. */
export const ehDaEquipeSupervisionada = (p: PerfilSupervisao | null | undefined): boolean => {
  if (!p || !ativo(p)) return false;
  const funcao = funcaoComercial(p);
  return funcao !== null && FUNCOES_COM_RODIZIO.includes(funcao);
};

/** Responsáveis que quem supervisiona enxerga no CRM: ele mesmo, mais Closers e BDRs. */
export const escopoDaSupervisao = (eu: PerfilSupervisao & { id: string }, perfis: readonly PerfilSupervisao[]): string[] =>
  [...new Set([eu.id, ...perfis.filter(ehDaEquipeSupervisionada).map(p => String(p.id))])];

/** Para quem quem supervisiona (sem outra permissão de transferência) pode passar uma negociação. */
export const podeReceberDaSupervisao = (eu: PerfilSupervisao | null | undefined, alvo: PerfilSupervisao | null | undefined): boolean =>
  !!eu && !!alvo && (String(alvo.id) === String(eu.id) || ehDaEquipeSupervisionada(alvo));
